import React, { useContext } from "react";
import themeContext from "../../../../context/theme/ThemeContext";

const QCReviewIcon = (props) => {
  const { themeName, getThemeColor,getThemeColorForTab} = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <g clipPath="url(#clip0_7961_162827)">
        <path
          d="M11.3335 16.5V14.1938L15.4772 10.0688C15.5897 9.95625 15.7147 9.875 15.8522 9.825C15.9897 9.775 16.1272 9.75 16.2647 9.75C16.4147 9.75 16.5585 9.77812 16.696 9.83438C16.8335 9.89062 16.9585 9.975 17.071 10.0875L17.7647 10.7812C17.8647 10.8938 17.9429 11.0188 17.9991 11.1562C18.0554 11.2937 18.0835 11.4313 18.0835 11.5688C18.0835 11.7063 18.0585 11.8469 18.0085 11.9906C17.9585 12.1344 17.8772 12.2625 17.7647 12.375L13.6397 16.5H11.3335ZM12.4585 15.375H13.171L15.4397 13.0875L15.1022 12.7313L14.746 12.3938L12.4585 14.6625V15.375ZM5.3335 16.5C4.921 16.5 4.56787 16.3531 4.27412 16.0594C3.98037 15.7656 3.8335 15.4125 3.8335 15V3C3.8335 2.5875 3.98037 2.23438 4.27412 1.94063C4.56787 1.64688 4.921 1.5 5.3335 1.5H11.3335L15.8335 6V8.25H14.3335V6.75H10.5835V3H5.3335V15H9.8335V16.5H5.3335ZM15.1022 12.7313L14.746 12.3938L15.4397 13.0875L15.1022 12.7313Z"
          // fill={themeName != "light"?props.active?"white":"#bfbfbf":getThemeColor("icon-color")}
          fill={getThemeColorForTab(props.active)}
        />
      </g>
      <defs>
        <clipPath id="clip0_7961_162827">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0.833496)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default QCReviewIcon;
